module.exports = __webpack_public_path__ + "static/media/NextModule.1ee6545f.svg";